import React from 'react';
import { Portal } from 'react-portal';
import styled from 'styled-components/macro';
import { AnimatePresence, motion } from 'framer-motion';
import CloseIcon from 'components/CloseIcon';

const Popup = ({ children, isOpen, onClose, className, fullScreen = true, closeButtonInside = false }) => {
    return (
        <Portal>
            <AnimatePresence>
                {isOpen && (
                    <Container 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                    >
                        <Overlay 
                            onClick={onClose}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.2 }}
                        />

                        {!closeButtonInside && (
                            <CloseButton closeButtonInside={closeButtonInside} onClick={onClose}>
                                <CloseIcon />
                            </CloseButton>
                        )}

                        <Content 
                            onClick={(e) => e.stopPropagation()}
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.9 }}
                            transition={{ duration: 0.2 }}
                            fullScreen={fullScreen}
                        >
                            {closeButtonInside && (
                                <CloseButton closeButtonInside={closeButtonInside} onClick={onClose}>
                                    <CloseIcon />
                                </CloseButton>
                            )}
                            {children}
                        </Content>
                    </Container>
                )}
            </AnimatePresence>
        </Portal>
    );
};

export default Popup;

const Container = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Overlay = styled(motion.div)`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
`;

const Content = styled(motion.div)`
    position: relative;
    ${props => props.fullScreen && `
        width: 100%;
        height: 100%;
    `}
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

const CloseButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
    
    display: flex;
    align-items: center;
    justify-content: center;
    width: 6rem;
    height: 6rem;
    font-size: 2.5rem;
    line-height: 1;
    
    padding: 0;
    border: none;
    border-radius: 0;
    outline: none;
    
    color: ${props => props.theme.secondary_color};
    background: ${props => props.theme.primary_color};
    cursor: pointer;
    
    transition: all .3s;
    
    &:hover {
        background: ${props => props.theme.primary_color_highlight};
    }
`;
